module.exports = __webpack_public_path__ + "img/profile.b84e94b3.png";